import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtRM, fmtDate } from "../../lib/format";
import { PageTitle, Spinner } from "../../components/Shell";

export default function Shares() {
  const [txns, setTxns] = useState(null);

  useEffect(() => {
    api.get("/portal/shares").then((r) => setTxns(r.data.transactions)).catch(() => {});
  }, []);

  if (!txns) return <Spinner />;
  const total = txns.reduce((s, t) => s + (t.type === "withdrawal" ? -t.amount : t.amount), 0);

  return (
    <div data-testid="portal-shares" className="max-w-4xl mx-auto">
      <PageTitle title="Saham Saya" sub="Sejarah transaksi saham koperasi" />
      <div className="bg-brand-dark rounded-xl p-5 text-white mb-5 flex items-center justify-between">
        <span className="text-xs uppercase tracking-[0.15em] text-emerald-100/60">Baki Semasa</span>
        <span className="font-mono text-2xl font-bold text-gold">{fmtRM(total)}</span>
      </div>
      <div className="bg-card rounded-xl border border-brand-deep/10 overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-brand-deep/10 text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-5 py-3">Tarikh</th><th className="px-5 py-3">Jenis</th><th className="px-5 py-3">Nota</th><th className="px-5 py-3 text-right">Amaun</th>
            </tr>
          </thead>
          <tbody>
            {txns.map((t) => (
              <tr key={t.txn_id} className="border-b border-brand-deep/5" data-testid={`portal-share-row-${t.txn_id.slice(-6)}`}>
                <td className="px-5 py-3 text-xs">{fmtDate(t.date)}</td>
                <td className="px-5 py-3"><span className={`text-xs font-bold uppercase ${t.type === "withdrawal" ? "text-red-500" : "text-brand-vivid"}`}>{t.type}</span></td>
                <td className="px-5 py-3 text-xs text-muted-foreground">{t.note || "-"}</td>
                <td className={`px-5 py-3 text-right font-mono font-semibold ${t.type === "withdrawal" ? "text-red-500" : "text-brand-deep"}`}>
                  {t.type === "withdrawal" ? "-" : "+"}{fmtRM(t.amount)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {txns.length === 0 && <p className="px-5 py-8 text-center text-sm text-muted-foreground">Tiada transaksi saham.</p>}
      </div>
    </div>
  );
}
